/* eslint-disable */
function mobileNavigationInit() {
  const button = document.querySelector('.header__mob-nav');

  if (!button) return false;

  const menuBlock = document.querySelector('.nav');
  const menu = menuBlock.querySelector('ul');

  if (getComputedStyle(menuBlock).visibility === 'hidden') {
    menuBlock.setAttribute('aria-hidden', true);
  }

  const toggle = () => {
    const headerInner = document.querySelector('.header__inner');
    button.classList.toggle('is-active');
    menuBlock.classList.toggle('is-active');

    document.documentElement.classList.toggle('no-scroll');
    document.body.classList.toggle('no-scroll');

    if (menuBlock.classList.contains('is-active')) {
      menuBlock.setAttribute('aria-hidden', false);
      button.setAttribute('aria-expanded', true);
      //fix for communication panel
      headerInner.classList.add('open');

      menuBlock.style.height = `${window.innerHeight}px`;

      menuBlock.addEventListener('click', menuOnClickHandler);
    } else {
      menuBlock.setAttribute('aria-hidden', true);
      button.setAttribute('aria-expanded', false);
      //remove class for communication panel
      headerInner.classList.remove('open');

      menuBlock.style.height = '';
      menuBlock.removeEventListener('click', menuOnClickHandler);
    }
  };

  const menuOnClickHandler = e => e.target === menuBlock && toggle();

  button.addEventListener('click', toggle);
}

// eslint-disable-next-line consistent-return
function stickyHeaderInit() {
  const header = document.querySelector('[data-header-fixed]');

  if (!header) return false;

  const onScrollHandler = function() {
    const topOffset = window.scrollY ? window.scrollY : window.pageYOffset;

    if (topOffset > header.offsetHeight + 120) {
      header.classList.add('sticky');
    } else {
      header.classList.remove('sticky');
    }
  };

  window.addEventListener('scroll', onScrollHandler);
}

window.addEventListener('DOMContentLoaded', () => {
  mobileNavigationInit();
  stickyHeaderInit();
});
/* eslint-enable */
